import React, { useState, Fragment, useEffect } from "react";
import {
  Menu,
  Input,
  Space,
  Dropdown,
  Button,
  Radio,
  Select,
  Form,
  Drawer,
} from "antd";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchKeySearchSkills } from "../../../../redux/actions";
import { FILTER_KEYS } from "../AllGigs/AllGigsFilter";
import { EXPERIENCE_COUNT, GIG_COUNT } from './../AllGigs/constants';



const ExperienceFilter = ({
  isSelected,
  label,
  handleApply,
  filterKey = FILTER_KEYS.ExperienceLevel,
  isMobileView = false,
  selectedOptions,
  setSelectedOptions,
  value,
}) => {
  const redux = useSelector((state) => state.myGigsFilterReducer);
  const [isOpen, setIsOpen] = useState(false);
    const [isError, setIsError] = useState(false);
  const [options, setoptions] = useState([]);
    const [list, setList] = useState([]);

  useEffect(() => {
    if (filterKey == FILTER_KEYS.ExperienceLevel) {
      setoptions(EXPERIENCE_COUNT || []);
    } else {
      setoptions(GIG_COUNT || []);
    }
  }, []);

  const handleOpen = (e) => {
    setIsOpen(e);
    if (!value) setSelectedOptions(null);
  };

  const getTitle = (item) => {
    switch (filterKey) {
    case FILTER_KEYS.ExperienceLevel:
      return item?.title || "";
    default:
      return item?.title;
  }
};
const getItemId = (item) => {
  switch (filterKey) {
    case FILTER_KEYS.ExperienceLevel:
      return item?.title || "";
    default:
      return item?.title || "";
  }
  };

  const onChangeRadio = (e) => {
    const item = JSON.parse(e.target.value) || {};
    const itemId = getItemId(item);
    if (e.target.checked) {
      setSelectedOptions(item);
      handleApply([itemId], filterKey, [
        { title: getTitle(item), filterKey, id: itemId },
      ]);
    }
  };

  const onClickClear = () => {
    setIsOpen(false);
    setSelectedOptions(null);
    handleApply([], filterKey, []);
  };

  const menu = (
    <div className="location-suggestion-view">
      {/* <Radio.Group
        onChange={onChangeRadio}
        className="location-radios-grp radio-color"
      > */}
      <Space
        direction="vertical"
          className={"infinite-scroller mobile-no-scroller"}
        style={{  width: "103%", paddingRight: "8px" }}
      >
        <div
          className={`location-lists-container ${
            list?.length > 5 ? "show-scrollbar" : ""
          }`}
          style={{ maxHeight: "250px" }}  
        >
          {options?.length ? (
              <>
                {options.map((items, index) => {
                  return (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  marginTop: "10px",
                }}
                key={index}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "inherit",
                  }}
                >
                  <Radio
                          type={"radio"}
                    value={JSON.stringify(items)}
                    className="location-radio"
                    onChange={onChangeRadio}
                          checked={getTitle(selectedOptions) == getTitle(items)}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                            {" "}
                      <div>{getTitle(items)}</div>
                    </div>
                  </Radio>
                        {/* <>
                          {" "}
                          <div className="countDiv">
                            ({items?.count || 0})
                          </div>{" "}
                        </> */}
                </div>
              </div>
                  );
                })}
              </>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: "#7e7e7e",
              }}
            >
                {" "}
                No results found{" "}
            </div>
          )}
        </div>
      </Space>
    </div>
  );

  const [isShowDrawer, setIsShowDrawer] = useState(false);
  const getMenu = () => {
    return (
      <Menu
        className={`location-filter-menu ${
          isError === "city" && "filterError"
        }`}
      >
        <div className="location-filter-menu-inner">{menu}</div>
      </Menu>
    );
  };

  return isMobileView ? (
    <Fragment>
      <div className="Radio-grop-pvt-mkt">
        <Space className="Space-radio-pvt-mkt" direction="vertical">
          {options.map((items, ind) => (
            <Radio
              type="radio"
              value={JSON.stringify(items)}
              checked={getTitle(selectedOptions) === getTitle(items)}
              onChange={onChangeRadio}
              key={getTitle(items) + ind}
            >
              <span>{getTitle(items)}</span>
              <span>{items?.count || 0}</span>
            </Radio>
          ))}
        </Space>
      </div>
    </Fragment>
  ) : (
    <Dropdown
      overlayClassName="searchResultsFilterDropdown"
      overlay={getMenu()}
      trigger="click"
      open={isOpen}
      onOpenChange={handleOpen}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
    >
      <Button
        className={
          isSelected ? "visaStatus-dropdown-select" : "visaStatus-dropdown"
        }
      >
        {label} <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default ExperienceFilter;
